import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { ExtendProductSubscriptionPageParamsType } from '../../../models/types/RoutePath';
import { clearCurrentOrganization } from '../../../store/redux-slices/organizations';
import { organizationNameSelector } from '../../../store/redux-slices/organizations/selectors';
import { clearAACurrentSubscription } from '../../../store/redux-slices/subscriptions/airAmbulance';
import { clearSubscriptionExtensionSummary } from '../../../store/redux-slices/subscriptions/common';
import { loadOrganization } from '../../../store/saga-slices/organizations';
import { loadAASubscriptionOverview } from '../../../store/saga-slices/subscriptions/airAmbulance';
import { ILoadSubscriptionOverviewPayload } from '../../../store/saga-slices/subscriptions/airAmbulance/models';

export const useExtendAASubscriptionPage = () => {
  const { organizationId, subscriptionId } =
    useParams<ExtendProductSubscriptionPageParamsType>();

  const organizationName = useSelector(organizationNameSelector);

  const LoadOrganization = useActions(loadOrganization);
  const LoadSubscriptionOverview = useActions(loadAASubscriptionOverview);
  const ClearCurrentOrganization = useActions(clearCurrentOrganization);
  const ClearCurrentSubscription = useActions(clearAACurrentSubscription);
  const ClearSubscriptionExtensionSummary = useActions(
    clearSubscriptionExtensionSummary,
  );

  useEffect(() => {
    LoadOrganization(organizationId);
    const loadSubscriptionOverviewPayload: ILoadSubscriptionOverviewPayload = {
      organizationId,
      subscriptionId,
    };
    LoadSubscriptionOverview(loadSubscriptionOverviewPayload);
  }, [
    LoadOrganization,
    LoadSubscriptionOverview,
    organizationId,
    subscriptionId,
  ]);

  useEffect(
    () => () => {
      ClearCurrentOrganization();
      ClearCurrentSubscription();
      ClearSubscriptionExtensionSummary();
    },
    [
      ClearCurrentOrganization,
      ClearCurrentSubscription,
      ClearSubscriptionExtensionSummary,
    ],
  );

  return { organizationName, organizationId, subscriptionId };
};
